export default {
  exitingQuotations: [],
  quotation: {
    started: false,
    finished: false,
    step: 0,
    progress: 0,
    sentToDataBase: false,
    emailSent: false,
    user: {
      personalData: {
        name: "",
        email: "",
        gender: "",
        height: null,
        weight: null,
        birthDate: "",
        hasChildren: false,
        childrenQuantity: 1,
        documentType: "",
        documentDispatcher: "",
        documentNumber: null,
        cpf: "",
        phone: null,
        contactWay: ""
      },
      addressData: {
        country: "Brasil",
        zipCode: null,
        neighborhood: "",
        street: "",
        number: null,
        complement: "",
        city: "",
        state: ""
      },
      financialData: {
        protectionsValue: 0,
        selectedInsurer: {
          id: "",
          logo: "",
          name: "",
          value: null
        },
        profession: "",
        monthlyWins: "",
        politicallyExposed: false,
        retired: false,
        beneficiares: [
          {
            name: "",
            birthDate: null,
            kinship: "",
            participation: ""
          }
        ],
        paymentOption: "",
        bankInfos: {
          bank: "",
          agency: null,
          checkingAccount: null,
          cpfCheckingAccounter: "",
          payDay: null
        }
      }
    }
  },
  simulation: {
    age: null,
    started: false,
    set: false,
    insurers: {
      selected: null,
      list: [
        {
          id: "bradescoSeguros",
          name: "Bradesco Seguros",
          value: null,
          table: []
        },
        {
          id: "icatuSeguros",
          name: "Icatu Seguros",
          value: null,
          table: []
        },
        {
          id: "mongeralAegon",
          name: "Mongeral Aegon",
          value: null,
          table: []
        },
        {
          id: "portoSeguro",
          name: "Porto Seguro",
          value: null,
          table: []
        }
      ]
    }
  },
  lightbox: {
    show: false,
    title: "",
    content: ""
  }
};
